module.exports = __webpack_public_path__ + "img/whathot_bg_dots_darkblue.c8e69075.png";